import { render, staticRenderFns } from "./ProjectSettingsLanguages.vue?vue&type=template&id=84ffe1a2&scoped=true"
import script from "./ProjectSettingsLanguages.vue?vue&type=script&lang=js"
export * from "./ProjectSettingsLanguages.vue?vue&type=script&lang=js"
import style0 from "./ProjectSettingsLanguages.vue?vue&type=style&index=0&id=84ffe1a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ffe1a2",
  null
  
)

export default component.exports